import React from 'react'
import Link from 'next/link'

const RouterLink = (props: any) => <Link {...props} to={props.to || props.href} href={props.to || props.href} />

export default RouterLink
